import Form from '../../../../components/Form/Form'

import { graphqlClient, gql } from '../../../../utils/gql'

import authProvider from '../../../../utils/auth-provider'

export default function DashboardEbpcApplicationReviewerForm (props = {
    id: null,
    ebpc_reviewer_id: null,
    approved: null,
    created_at: null,
    updated_at: null,
    ebpc_application: null
}) {
    if (authProvider.getIdentity().id !== props.ebpc_reviewer_id
            || (props.ebpc_application || {}).ebpc_review_approved
                !== props.approved)
        return null

    const onSubmit = async (e) => {
        const formData = new window.FormData(e.target)

        let approved = formData.get('approved') || null

        if (approved)
            approved = approved === 'true'

        const mutation = await graphqlClient
            .request(gql`
                mutation {
                    update_ebpc_reviews_by_pk (
                        pk_columns: { id: "${props.id}" },
                        _set: {
                            approved: ${approved}
                        }
                    ) {
                        id
                    }
                }
            `, {}, {
                headers: {
                    'x-hasura-role': 'ebpc_reviewer'
                }
            })
            .catch(err => console.warn(err))

        return mutation
    }

    return (
        <Form
            onSubmit={onSubmit}
            enableOnChange
        >
            <fieldset className="form-field">
                <legend>
                    Please select whether or not this venture's application
                    should advance to the judging round. If uncertain,
                    please select "Undecided".
                </legend>
                <div className="display-flex margin-t">
                    <input
                        id="ebpc-reviewer-approved-0"
                        name="approved"
                        type="radio"
                        value="true"
                        defaultChecked={props.approved}
                        required
                    />
                    <label
                        htmlFor="ebpc-reviewer-approved-0"
                    >
                        Advance
                    </label>
                </div>
                <div className="display-flex margin-1-t">
                    <input
                        id="ebpc-reviewer-approved-1"
                        name="approved"
                        type="radio"
                        value=""
                        defaultChecked={props.approved === null
                            && props.created_at !== props.updated_at}
                        required
                    />
                    <label
                        htmlFor="ebpc-reviewer-approved-1"
                    >
                        Undecided
                    </label>
                </div>
                <div className="display-flex margin-1-t">
                    <input
                        id="ebpc-reviewer-approved-2"
                        name="approved"
                        type="radio"
                        value="false"
                        defaultChecked={props.approved === false}
                        required
                    />
                    <label
                        htmlFor="ebpc-reviewer-approved-2"
                    >
                        Do not advance
                    </label>
                </div>
                <p
                    role="alert"
                    id="ebpc-reviewer-approved-invalid"
                >
                    A choice on advancement is required
                </p>

                <div className="margin-t">
                    <button
                        className="btn btn-secondary"
                        type="submit"
                        style={{
                            paddingTop: 15,
                            paddingBottom: 15
                        }}
                        disabled
                    >
                        Submit
                    </button>
                </div>
            </fieldset>
        </Form>
    )
}
